import { search } from '../../../../../../utils/search';
import { AXON } from '../../../../../../utils/search/constants';
import type {
  FuzzysortResult,
  SearchDataset,
  SearchResultItem,
} from '../../GlobalMapSearch.types';
import { IGNORED_SPECIAL_CHARACTERS } from '../../GlobalMapSearch.utils';

interface RunAxonSearchArgs {
  text: string;
  axonDs: SearchDataset[] | undefined;
  collected: SearchResultItem[];
  flush: () => void;
}

/**
 * Synchronous fuzzy match against the in-memory Axon responder dataset.
 * Pushes hits straight into `collected` and triggers a single flush.
 *
 * Sits under `search/dynamic/` because Axon is a dynamic spatial layer; it
 * keeps its specialized officer/badge fuzzy keys (via `selectAxon`) instead
 * of going through the generic `spatialAttributeSearch` path.
 */
export function runAxonSearch({
  text,
  axonDs,
  collected,
  flush,
}: RunAxonSearchArgs): void {
  const axonResults: FuzzysortResult[] =
    search(text.replace(IGNORED_SPECIAL_CHARACTERS, ''), axonDs) || [];
  axonResults
    .filter(r => r.data?.source === AXON)
    .forEach(r => collected.push({ type: 'axon', data: r.data }));
  flush();
}
